import axios from "@/api/axios";

const getReviews = (params = {}) => {
  return axios.get(`/reviews`, { params });
};

const getReviewDepartments = () => {
  return axios.get(`/reviews/departments`);
};

const getReviewEmployees = (search = "", departmentId = "") => {
  const params = { search };
  if (departmentId) params.departmentId = departmentId;
  return axios.get(`/reviews/employees`, { params });
};

const submitReview = (payload) => {
  return axios.post(`/reviews/submit`, payload);
};

export default {
  getReviews,
  getReviewDepartments,
  getReviewEmployees,
  submitReview,
};
